import { IGetUsuarioDropDownUseCase } from "../../../presentation/useCases/read/get_usuario_drop_down_use_case";
import { UsuarioDropDown } from "../../models/usuario_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetUsuarioDropDownUseCase
 */

export class GetUsuarioDropDownUseCase implements IGetUsuarioDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getUsuarioDropdown(): Promise<UsuarioDropDown[]> {
    return await this.repository.getUsuarioDropDown();

  }
}
